(function () {
    'use strict';

	/*
	 ProductDetailsController
	-------------------------------------------------------------------------- */

    angular
        .module('PublicApp.productDetails', [])
        .controller('ProductDetailsController', [
            '$scope',
            '__DataStore',
            'appServices',
            '$stateParams',
            '__Form',
            '$rootScope',
            '$state',
            '__Utils',
            '$q',
            '$compile',
            '__Auth',
            'appNotify',
            ProductDetailsController
        ])
		/**
         * AddReviewDialogController
         *
         * @inject $scope
         * @inject __DataStore
         * @inject appServices
         *
         * @return void
         *-------------------------------------------------------- */
        .controller('AddReviewDialogController', [
            '$scope',
            'appServices',
            '__Form',
            'GetReviewData',
            function AddReviewDialogController($scope, appServices, __Form, GetReviewData) {

                var scope = this;
                scope.pageStatus = false;
                scope.ngDialogData = $scope.ngDialogData;

                scope = __Form.setup(scope, 'item_review_add_form', 'reviewData');

                var reviewData = GetReviewData.reviewData;

                scope = __Form.updateModel(scope, {
                    'review': (_.isEmpty(reviewData)) ? '' : reviewData
                });

                scope.pageStatus = true;

                /**
                  * add review on item
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.submitReview = function () {

                    __Form.process({
                        'apiURL': 'product.process.add.review',
                        'productId': scope.ngDialogData.productId
                    }, scope)
                        .success(function (responseData) {

                            appServices.processResponse(responseData, null, function () {
                                $scope.closeThisDialog();
                            });

                        });

                };

                /**
                  * Close dialog
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.closeDialog = function () {
                    $scope.closeThisDialog();
                };
            }
        ])

		/**
          * Item Details Dialog Controller 
          *
          * @inject object $scope
          * @inject object appServices
          *
          * @return void
          *---------------------------------------------------------------- */

        .controller('ItemRatingAndReviewDialogController', [
            '$scope',
            'appServices',
            'GetRatingAndReviewData',
            function ($scope, appServices, GetRatingAndReviewData) {

                var scope = this,
                    ngDialogData = $scope.ngDialogData;
                scope.itemTitle = ngDialogData.itemTitle;
                scope.pageStatus = false;

                scope.itemRatingAndReview = GetRatingAndReviewData.data.itemRatingAndReview;

                if (ngDialogData) {
                    scope.pageStatus = true;
                }

                /**
                   * Close this dialog
                   *
                   * @return void
                   *-----------------------------------------------------------------------*/
                scope.closeDialog = function () {
                    $scope.closeThisDialog();
                };
            }
        ])

        /**
          * Item Details Dialog Controller 
          *
          * @inject object $scope
          * @inject object appServices
          *
          * @return void
          *---------------------------------------------------------------- */

        .controller('ProductFaqsDialogController', [
            '$scope',
            'appServices',
            '__Form',
            function ($scope, appServices, __Form) {

                var scope = this,
                    ngDialogData = $scope.ngDialogData;
                scope.productTitle = ngDialogData.itemTitle;
                scope.productID = __globals.getAppJSItem('productID');

                scope = __Form.setup(scope, 'faq_add_form', 'addFaqData');

                /**
                  * add review on item
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.submitFaq = function () {

                    __Form.process({
                        'apiURL': 'product.process.add.faqs',
                        'productId': scope.productID,
                        'type': 2
                    }, scope)
                        .success(function (responseData) {

                            appServices.processResponse(responseData, null, function () {
                                $scope.closeThisDialog();
                            });

                        });

                };

                /**
                   * Close this dialog
                   *
                   * @return void
                   *-----------------------------------------------------------------------*/
                scope.closeDialog = function () {
                    $scope.closeThisDialog();
                };
            }
        ])

    /**
     * ProductDetailsController for product details application
     * 
     * @inject __DataStore
     * @inject appServices
     * @inject $scope
     * @inject $stateParams
     * @inject __Form
     * @inject $state
     * @inject $rootScope
     * 
     * @return void
     *-------------------------------------------------------- */

    function ProductDetailsController($scope, __DataStore, appServices,
        $stateParams, __Form, $rootScope, $state, __Utils, $q, $compile, __Auth, appNotify) {

        var scope = this;
        scope.isLoggedIn = __Auth.isLoggedIn();
        scope.productID = __globals.getAppJSItem('productID');
        scope.categoryID = __globals.getAppJSItem('categoryID');
        scope.currencySymbol = __globals.getAppJSItem('currencySymbol');
        scope.productStatus = __globals.getAppJSItem('productStatus');
        scope.currencyValue = __globals.getAppJSItem('currencyValue');
        scope.launchingDate = __globals.getAppJSItem('launchingDate');
        scope.isAddedInWishlist = __globals.getAppJSItem('isAddedInWishlist');
        scope.images = __globals.getAppJSItem('images');
        scope.defaultImages = __globals.getAppJSItem('defaultImages');
        scope.isActiveCategory = __globals.getAppJSItem('isActiveCategory');

        var ratingsData = __globals.getAppJSItem('productRatings');

        scope.itemRating = ratingsData.itemRating;
        scope.itemRatingOrReview = ratingsData.itemRating.itemRatingOrReview;
        scope.enableRating = ratingsData.enableRating;
        scope.enableRatingReview = ratingsData.enableRatingReview;
        scope.restrictAddRating = ratingsData.restrictAddRating;
        scope.enableRatingModification = ratingsData.enableRatingModification;
        scope.isPurchsedProduct = ratingsData.isPurchsedProduct;

        scope = __Form.setup(scope, 'add_product_in_cart_form', 'productData', {
            modelUpdateWatcher: false
        });

        scope.pageStatus = false;
        scope.optionLength = false;
        scope.inActiveCategory = false;

        //check if category & product is inactive
        if (_.isEmpty(scope.isActiveCategory) || scope.productStatus != 1) {
            scope.inActiveCategory = true;
            //product share button add disabled class
            $('.lw-product-share-btn').addClass('disabled');
        } else {
            //product share button remove disabled class
            $('.lw-product-share-btn').removeClass('disabled');
        }

        scope.isEnableReating = function () {

            scope.isEnableRatingModification = true;

            // this condition check used for enable rating modification
            if (_.isEmpty(scope.itemRating.selfRating)
                && scope.enableRatingModification == false) {

                scope.isEnableRatingModification = false;

            } else if (!_.isEmpty(scope.itemRating.selfRating)
                && scope.enableRatingModification == true) {

                scope.isEnableRatingModification = false;

            } else if (_.isEmpty(scope.itemRating.selfRating)
                && scope.enableRatingModification == true) {

                scope.isEnableRatingModification = false;

            } else if (scope.restrictAddRating == true
                && scope.enableRatingModification == true) {

                scope.isEnableRatingModification = true;
            }

            if (scope.restrictAddRating == true
                && scope.isPurchsedProduct == false) {

                scope.isEnableRatingModification = true;
            }

        };
        scope.isEnableReating();

        if (scope.enableRatingModification == true && scope.productStatus != 1) {
            scope.isEnableRatingModification = true;
        } else if (_.isEmpty(scope.isActiveCategory)) {
            scope.isEnableRatingModification = true;
        }

        //product rating bar start
        // $('#lw-bar-rating').data('current-rating')
        $(function () {
            $('#lw-bar-rating').barrating('show', {
                theme: 'fontawesome-stars-o',
                showValues: false,
                allowEmpty: false,
                readonly: scope.isEnableRatingModification,
                initialRating: scope.itemRating.selfRating,
                onSelect: function (value, text, event) {
                    if (typeof (event) !== 'undefined') {
                        // rating was selected by a user
                        // console.log(value);
                        if (!window.__appImmutables.auth_info.authorized) {
                            appServices.loginRequiredDialog('login-dialog', null, function (promiseObj) {
                                if (promiseObj == true) {
                                    scope.submitRatingAndReview(value);
                                }
                            });

                        } else if (scope.enableRating == true) {
                            scope.submitRatingAndReview(value);
                        }
                    } else {
                        // rating was selected programmatically
                        // by calling `set` method
                    }
                }
            });
        });
        //product rating bar end


        var drift = '';

        scope.prepareZoomImage = function (imageURL) {

            if (drift) {
                drift.destroy();
            }

            var triggerEl = document.querySelector('img.lw-zoom-image');

            drift = new Drift(triggerEl, {
                paneContainer: document.querySelector('.lw-zoom-detail'),
                namespace: 'lw-zoom-panel',
                inlinePane: 900,
                inlineOffsetY: -85,
                containInline: true,
                zoomFactor: 4,
                hoverBoundingBox: true
            });

            _.defer(function () {

                if (!_.isUndefined(imageURL)) {

                    drift.setZoomImageURL(imageURL);

                    $(triggerEl).attr('src', imageURL);

                    triggerEl.setAttribute("data-zoom", imageURL);
                }

            }, 100);

        }

        _.defer(function () {
            scope.prepareZoomImage();
        });

        scope.currentImageIndex = 0;
        // Show all images from selected group
        scope.showImagesInColorBox = function (showImages) {
            $('.lw-zoom-panel-bounding-box').remove();
            $('.lw-zoom-detail').html('');
            var $gallery = $("a[rel=lw-product-images]").colorbox({
                transition: "none", width: "90%", height: "90%", fixed: true
            });
            $gallery.eq(scope.currentImageIndex).click();
        }

        scope.previewImageUrl = '';
        // Prepare Url for preview image
        scope.changeImage = function (imageUrl, e, index) {
            e.preventDefault();
            scope.currentImageIndex = index;
            scope.previewImageUrl = imageUrl;
            _.defer(function () {
                scope.prepareZoomImage(imageUrl);
            });
            event.stopImmediatePropagation();
        }

        //add product compare function start
        scope.addProductCompare = function (productId) {

            __DataStore.post({
                'apiURL': 'product.compare.add',
                'productId': productId
            }, scope).success(function (responseData) {
                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {

                    if (reactionCode == 1) {
                        scope.productDetails.addedInCompareList = true;
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }
                });

            });
        }
        //add product compare function end

        //remove product compare function start
        scope.removeProductCompare = function (productId) {

            __DataStore.post({
                'apiURL': 'product.compare.remove',
                'productId': productId
            }, scope).success(function (responseData) {
                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {

                    if (reactionCode == 1) {
                        scope.productDetails.addedInCompareList = false;
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }
                });

            });
        }
        //remove product compare function end

        //notify user email functionality
        scope.notifyUser = function (userEmail) {

            if (!_.isEmpty(userEmail)) {
                __DataStore.post({
                    'apiURL': 'product.notify_user.add',
                    'productId': scope.productID
                }, {
                    'notifyUserEmail': scope.notifyUserEmail
                }).success(function (responseData) {

                    appServices.processResponse(responseData, function () {

                        if (_.has(responseData.data, 'validation')) {
                            var errorMessage = responseData.data.validation.notifyUserEmail[0];
                            if (errorMessage) {
                                appNotify.error(errorMessage);
                            }
                        }

                    }, function () {
                        scope.notifyUserEmail = '';
                    });
                });
            }
        }
        //notify user email functionality

        /**
        * display all active products list
        *
        * @return void
        *---------------------------------------------------------------- */

        scope.getProductDetails = function () {

            // send http request to server
            __DataStore.fetch({
                'apiURL': 'product.quick.view.details.support_data',
                'productID': scope.productID,
                'categoryID?': scope.categoryID
            }).success(function (responseData) {

                appServices.processResponse(responseData, null, function (reactionCode) {

                    var requestData = responseData.data.details;

                    scope.productDetails = requestData;
                    scope.itemRatingAndReview = requestData.itemRatingOrReview.itemRatingAndReview;
                    scope.originalRatingAndReviewCount = requestData.itemRatingOrReview.originalRatingAndReviewCount;
                    scope.reviewCount = requestData.itemRatingOrReview.reviewCount;
                    scope.configReviewCount = requestData.itemRatingOrReview.configReviewCount;
                    scope.totalReview = requestData.itemRatingOrReview.totalReview;
                    scope.productSpecExists = requestData.productSpecExists;
                    scope.productQuestion = scope.productDetails.productQuestionData.productQuestionData;

                    scope.productDiscount = scope.productDetails.productDiscount;

                    var $discount = $compile(__Utils.template('#discountDetailsTemplate', scope.productDiscount))(scope);
                    scope.discountDetailsHtml = $discount.html();

                    scope.productData = {
                        'name': scope.productDetails.name,
                        'quantity': 1,
                        'isCartExist': false
                    };

                    scope = __Form.updateModel(scope, scope.productData);

                    scope.productDetails.basePriceWithAddonPrice = requestData.newTotalPrice;

                    scope.newTotalPriceCount = requestData.newTotalPriceCount;

                    scope.productDetails.selectedOptions = requestData.getSelectedOptions;

                    if (scope.productDetails) {
                        scope.productData.name = requestData.name;
                    }

                    if (!_.isEmpty(scope.productDetails.getSelectedOptions)) {
                        scope.optionLength = true;
                    }

                    scope.productDetails.priceDetails = {
                        'option': requestData.getSelectedOptions,
                        'total': requestData.getPrice.total,
                        'base_price': requestData.getPrice.base_price
                    };

                    // product quantity
                    if (requestData.qtyCart > 0) {

                        scope.productData.quantity = requestData.qtyCart;
                        scope.checkNumber = true;

                    } else {
                        scope.productData.quantity = 1;
                    }

                    scope.isPurchsedProduct = requestData.isPurchsedProduct;
                    scope.btnQuantity = requestData.qtyCart;
                    scope.productData.isCartExist = requestData.isCartExist;

                    scope.pageStatus = true;

                });


            });
        };
        scope.getProductDetails();


        /**
          * Submit rating action
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.submitRatingAndReview = function (value) {
            if (!_.isEmpty(value)) {
                __DataStore.post({
                    'apiURL': 'product.rating.add',
                    'productId': scope.productID,
                    'rate': value
                }, scope).success(function (responseData) {

                    appServices.processResponse(responseData, null, function () {

                        scope.itemRating = responseData.data.itemRating;

                        // if is allow for review
                        if (scope.itemRating.showDialog == true) {
                            scope.showAddReviewDialog(responseData.data);
                        }

                        scope.isEnableReating();

                    });

                    scope.getProductDetails();
                });
            }
        };

        /**
          * Show user login dialog
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.showAddReviewDialog = function (responseData) {

            appServices.showDialog({
                'reviewData': responseData,
                'productId': scope.productID
            },
                {
                    templateUrl: __globals.getTemplateURL('product.add-review-dialog'),
                    controller: "AddReviewDialogController as AddReviewDialogCtrl",
                    resolve: {
                        GetReviewData: function () {

                            //create a differed object          
                            var defferedObject = $q.defer();

                            __DataStore.fetch({
                                'apiURL': 'product.review.support.data',
                                'productId': scope.productID
                            }).success(function (responseData) {

                                appServices.processResponse(responseData, null, function (reactionCode) {

                                    //this method calls when the require        
                                    //work has completed successfully        
                                    //and results are returned to client        
                                    defferedObject.resolve(responseData);

                                });

                            });

                            //return promise to caller          
                            return defferedObject.promise;
                        }
                    }
                },
                function (promiseObj) {

                    scope.getProductDetails();
                });

        };

        /**
         * Create FAQs Dialog for this item
         *
         * @return void
         *---------------------------------------------------------------- */

        scope.addQuestionDialog = function () {

            appServices.showDialog({
                'itemTitle': scope.productData.name
            },
                {
                    templateUrl: __globals.getTemplateURL('product.add-faqs-dialog'),
                    controller: "ProductFaqsDialogController as ProductFaqsCtrl",
                    resolve: {}
                },
                function (promiseObj) {

                });
        };

        /**
          * Show Ratings of this item
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.showRatingAndReviews = function () {

            appServices.showDialog({
                'itemTitle': scope.productData.name
            },
                {
                    templateUrl: __globals.getTemplateURL('product.ratings-and-reviews-dialog'),
                    controller: "ItemRatingAndReviewDialogController as RatingAndReviewCtrl",
                    resolve: {
                        GetRatingAndReviewData: function () {

                            //create a differed object          
                            var defferedObject = $q.defer();

                            __DataStore.fetch({
                                'apiURL': 'product.rating_review.get_support_data',
                                'productId': scope.productID
                            }).success(function (responseData) {

                                appServices.processResponse(responseData, null, function (reactionCode) {

                                    //this method calls when the require        
                                    //work has completed successfully        
                                    //and results are returned to client        
                                    defferedObject.resolve(responseData);

                                });

                            });

                            //return promise to caller          
                            return defferedObject.promise;
                        }
                    }
                },
                function (promiseObj) {
                    scope.getProductDetails();
                });
        };


        /**
        * increment decrement quantity
        *
        * @param boolean status 
        * @param int quantity
        *
        * @return void
        *---------------------------------------------------------------- */
        scope.getQtyAction = function (status, quantity) {

            // if product status is true 
            if (status == true) {
                (quantity == undefined || isNaN(quantity))
                    ? scope.productData.quantity = 1
                    : scope.productData.quantity = quantity + 1;

            } else {
                // product quantity must be greterThan -1
                var newValue = (quantity - 1);
                (newValue <= 0)
                    ? scope.productData.quantity = 1
                    : scope.productData.quantity = newValue;
            }

        };


        /**
      * Add product as a cart item
      *
      * @return void
      *---------------------------------------------------------------- */
        scope.cartAction = false;

        scope.addToCart = function () {

            __Form.process({
                apiURL: 'cart.add.item',
                productID: scope.productID
            }, scope).success(function (responseData) {

                scope.cartAction = true;

                var requestData = responseData.data;

                appServices.processResponse(
                    responseData,
                    null,
                    function () {

                        scope.data = {
                            'cart_string': responseData.data.cartItems,
                            'status': true
                        }
                        scope.updateCartRow(scope.productID, true);
                        $scope.$emit('lw.update.cart.string', scope.data);
                    }
                );

            });
        };

        /**
          * Add to Wish-list
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.addToWishlist = function () {
            if (!window.__appImmutables.auth_info.authorized) {

                appServices.loginRequiredDialog('login-dialog', null, function (result) { });

            } else {
                __DataStore.post({
                    'apiURL': 'product.wishlist.add_process',
                    'productId': scope.productID
                }, scope).success(function (responseData) {

                    var requestData = responseData.data;
                    if (requestData.showLoggedInDialog) {
                        appServices.loginRequiredDialog('login-dialog', null, function (result) { });
                    }

                    appServices.processResponse(responseData, null, function (reactionCode) {
                        if (reactionCode == 1) {
                            scope.isAddedInWishlist = true;
                        }
                    });
                });
            }
        };

        /**
          * Remove from Wish-list
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.removeFromWishlist = function () {
            __DataStore.post({
                'apiURL': 'product.wishlist.remove_process',
                'productId': scope.productID
            }, scope).success(function (responseData) {
                var requestData = responseData.data;
                if (requestData.showLoggedInDialog) {
                    appServices.loginRequiredDialog('login-dialog', null, function (result) { });
                }

                appServices.processResponse(responseData, null, function (reactionCode) {

                    if (reactionCode == 1) {
                        scope.isAddedInWishlist = false;
                    }
                });
            });
        };

        // when the cart item remove from to cart
        $rootScope.$on('remove.cart.row', function (events, resposeData) {

            if (resposeData.status) {
                //scope.getProductDetails();
                scope.updateCartRow(scope.productID, true);
            };

        });

		/**
		  * Add product as a cart item
		  *
		  * @return void
		  *---------------------------------------------------------------- */

        scope.updateCartRow = function (productID, option, options) {
            var checkOption = true;

            scope.addonPrices = [];

            if (scope.productData.options != undefined) {
                // hold option of addon_price related data 
                scope.productDetails.selectedOptions = scope.productData.options[productID];
                angular.forEach(scope.productData.options[productID],
                    function (value, key) {

                        this.push({
                            option_name: key,
                            value_name: value.name,
                            addon_price: value.addon_price_format
                        });
                    }, scope.addonPrices);

                // hold empty options data 
                angular.forEach(scope.productData.options[productID],
                    function (value, key) {

                        if (value == '') {
                            checkOption = false;
                        }

                    }, checkOption);
            }

            var selectedOptions = _.pluck(scope.productDetails.selectedOptions, 'id');

            var counter = 0,
                optionProductImages = [];

            _.forEach(selectedOptions, function (item) {

                _.forEach(scope.images, function (row, index) {

                    if (item === row.product_option_values_id) {
                        counter++;
                        row.counter = counter;
                        optionProductImages.push(row);
                    }

                });

            })

            __Form.process({
                apiURL: 'cart.product.qty.update',
                productID: productID
            }, scope).success(function (responseData) {

                appServices.processResponse(
                    responseData,
                    null,
                    function (reactionCode) {

                        var requestData = responseData.data;

                        scope.productDetails.basePriceWithAddonPrice = requestData.formatedTotalPrice;

                        scope.productDetails.priceDetails = {
                            'option': scope.productDetails.selectedOptions,
                            'total': requestData.totalPrice,
                            'base_price': requestData.base_price
                        }

                        scope.productDiscount = requestData.productDiscount;

                        var $discount = $compile(__Utils.template('#discountDetailsTemplate', scope.productDiscount))(scope);
                        scope.discountDetailsHtml = $discount.html();

                        scope.productData.isCartExist = requestData.isCartExist;

                        if (requestData.qtyCart > 0) {
                            scope.productData.quantity = requestData.qtyCart;
                            scope.btnQuantity = requestData.qtyCart;
                        } else {
                            scope.btnQuantity = 0;
                            scope.productData.quantity = 1;
                        }
                    }
                );


            });

            if (optionProductImages.length > 0) {

                angular.element('.lw-main-slider-container').replaceWith($compile(__Utils.template('#lwMainSliderRow', {
                    'images': optionProductImages,
                    'firstImage': _.get(optionProductImages, 0)
                }))($scope));

                scope.prepareZoomImage();

            } else if (optionProductImages.length == 0) {

                angular.element('.lw-main-slider-container').replaceWith($compile(__Utils.template('#lwMainSliderRow', {
                    'images': scope.defaultImages,
                    'firstImage': _.get(scope.defaultImages, 0)
                }))($scope));

                scope.prepareZoomImage();
            }

        };

    }

})();